// extracted by mini-css-extract-plugin
export default {"routes":"routes-CFlnQ"};